import React from 'react';

export interface HeaderProps {
  title?: string;
  subtitle?: string;
  theme?: 'journey' | 'professional';
  children?: React.ReactNode;
}

export const Header: React.FC<HeaderProps> = ({ title = 'Meu Mapa NEV', subtitle, children }) => {
  const headerStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 'var(--nev-space-4) var(--nev-space-6)',
    backgroundColor: 'var(--nev-background-surface)',
    borderBottom: '1px solid var(--nev-border-subtle)',
    minHeight: '64px',
  };

  const titleGroupStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  };

  const titleStyle: React.CSSProperties = {
    fontFamily: 'var(--nev-font-heading)',
    fontSize: '1.25rem',
    fontWeight: 700,
    color: 'var(--nev-text-primary)',
    margin: 0,
  };

  const subtitleStyle: React.CSSProperties = {
    fontFamily: 'var(--nev-font-body)',
    fontSize: '0.875rem',
    color: 'var(--nev-text-secondary)',
    margin: 0,
  };

  return (
    <header className="nev-app-header" role="banner" style={headerStyle}>
      <div className="nev-brand">
        <img
          className="nev-brand-logo"
          src={new URL('../assets/nev-logo-principal.svg', import.meta.url).href}
          alt="NEV"
        />
        <div style={titleGroupStyle}>
          <p style={titleStyle}>{title}</p>
          {subtitle && <p style={subtitleStyle}>{subtitle}</p>}
        </div>
      </div>
      {children && (
        <nav className="nev-app-nav" aria-label="Navegação principal">
          {children}
        </nav>
      )}
    </header>
  );
};
